import { ZealApiSuccessResponse } from "@zeal/common";

import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  TGlobalSearchRequest,
  TGlobalSearchResponse,
} from "./getGlobalSearch.schema";

type SuccessResponse = ZealApiSuccessResponse<TGlobalSearchResponse>;

export const getGlobalSearch = (axios: IAxiosInstance) => {
  return async (params: TGlobalSearchRequest) => {
    try {
      const response = await axios.noRetry.get<SuccessResponse>(
        "/api/global-search",
        { params }
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
